import { useQuery } from "@apollo/client/react";
import { useEffect } from "react";
import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import { adaptDelegacionReclamosArray } from "../../../adapters/delegacionAdapter";
import { TextInput } from "../../../components/textInput/TextInput";
import { GET_DELEGACIONES_BY_USUARIO } from "../../../data/graphQL/queries/PacienteProbable/getAllDelegacionesByUsuario";
import { CustomButton } from "../../../components/customButton/CustomButton";

const userId = sessionStorage.getItem("idUsuario");

export function GestionEnviosFiltersHeader({
  filters,
  handleChange,
  handleTextClean,
  handleTextFilter,
  handleSearch,
  handleDelegacionChange,
  delegaciones,
  setDelegaciones
}) {
  const { data: delegacionesData} = useQuery(GET_DELEGACIONES_BY_USUARIO, {
    fetchPolicy: "no-cache",
    variables: { idUsuario: JSON.parse(userId, 10) }
  });

  useEffect(() => {
    if (!delegacionesData) return;
    setDelegaciones(adaptDelegacionReclamosArray(delegacionesData, false));
  }, [delegacionesData]);

  return (
    <Grid container spacing={2} mb="25px">
      <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
        <TextInput
          searchIcon
          label="Buscar"
          name="txtFiltro"
          onClearButtonClick={handleTextClean}
          value={filters?.txtFiltro}
          onChange={handleChange}
          onKeyUp={handleTextFilter} />
        
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
        <FormControl sx={{ bgcolor: "white", width: "100%" }} size="small">
          <InputLabel id="select-delegacion">Delegación</InputLabel>
          <Select
            labelId="select-delegacion"
            options={delegaciones}
            label="Delegación"
            onChange={handleDelegacionChange}
            value={filters?.idDelegacion || ""}
            name="idDelegacion">
            
            {delegaciones.map((delegacion) => {
              return (
                <MenuItem key={delegacion.id} value={delegacion.id}>
                  {" "}
                  {delegacion.displayName}{" "}
                </MenuItem>);

            })}
          </Select>
        </FormControl>
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 4, lg: 6 }} justifyContent="flex-end" display="flex">
        <CustomButton size="small" onClick={handleSearch}>
          Buscar
        </CustomButton>
      </Grid>
    </Grid>);

}